import { parseAbi } from "viem";

// Read interfaces from the supplied guide and Part A observations. These do not
// certify the current proxy's sweep implementation or authorize execution.
export const creatorFeeCurveAbi = parseAbi([
  "function token() view returns (address)",
  "function factory() view returns (address)",
  "function pairToken() view returns (address)",
  "function deployer() view returns (address)",
  "function feeEscrow() view returns (address)",
  "function graduated() view returns (bool)",
  "function quoteFeeBalance() view returns (uint256)",
  "function creatorTaxBalance() view returns (uint256)",
  "function protocolFeeShareBps() view returns (uint256)",
  "function buybackEnabled() view returns (bool)",
]);
export const creatorFeeVaultAbi = parseAbi([
  "function availableRewardWei(address sourceToken) view returns (uint256)",
  "function redemptionController() view returns (address)",
  "function sourceFeeReceiver(address sourceToken) view returns (address)",
]);
export const creatorFeeFactoryAbi = parseAbi([
  "function getLaunchedToken(address token) view returns ((address token,address curve,address deployer,address creatorFeeRecipient,address pairToken,uint256 graduationThreshold,uint24 poolFee,int24 tickSpacing,uint16 creatorTaxBps,bool buybackEnabled,uint8 phase,uint256 sweptQuote,uint256 sweptTokens,uint256 sweptAt,bool exists))",
]);
export const creatorFeeReceiverAbi = parseAbi([
  "function SOURCE_TOKEN() view returns (address)",
  "function FEE_VAULT() view returns (address)",
  "function UPSTREAM_ESCROW() view returns (address)",
  "function INSTANCE_ID() view returns (bytes32)",
]);
export const creatorFeeEscrowAbi = parseAbi([
  "function balanceOf(address recipient) view returns (uint256)",
]);
